import { Navigate, Outlet } from 'react-router-dom'
import { FullScreenSpinner } from '@/components/ui/FullScreenSpinner'
import type { Role } from '@/types/user'
import { useAuth } from './AuthContext'
import { roleHome } from './routes'

/**
 * Gate for role-specific route trees. A signed-in user whose role does not
 * match is redirected to their own dashboard (or /login if they have no role).
 * This is a UX guard only — real enforcement lives in Firestore/Storage rules.
 */
export function RequireRole({ allow }: { allow: Role }) {
  const { status, role } = useAuth()
  if (status === 'loading') {
    return <FullScreenSpinner />
  }
  if (status === 'unauthenticated') {
    return <Navigate to="/login" replace />
  }
  if (role !== allow) {
    return <Navigate to={roleHome(role)} replace />
  }
  return <Outlet />
}
